import { render } from "./Tab3.vue?vue&type=template&id=5e0672f4&scoped=true"
import script from "./Tab3.vue?vue&type=script&lang=js"
export * from "./Tab3.vue?vue&type=script&lang=js"

import "./Tab3.vue?vue&type=style&index=0&id=5e0672f4&scoped=true&lang=css"
import "./Tab3.vue?vue&type=style&index=1&id=5e0672f4&scoped=true&lang=scss"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0672f4"]])

export default __exports__